import * as CONSTRUCTOR from '../../generate';
import * as Fragments from './fragments';

export const LIST_UNIT_RESERVATION_REFUNDS = (props = {}) => {
  const defaultProps = {
    type: 'query',
    name: 'listUnitReservationRefunds',
    args: [
      { name: 'status', type: 'String' },
      { name: 'project_id', type: 'String' },
      { name: 'sort_column', type: 'String' },
      { name: 'sort_direction', type: 'String' },
      { name: 'limit', type: 'Int' },
      { name: 'page', type: 'Int' },
    ],
    argsMap: [
      { name: 'status', value: 'status' },
      { name: 'project_id', value: 'project_id' },
      { name: 'sort_column', value: 'sort_column' },
      { name: 'sort_direction', value: 'sort_direction' },
      { name: 'limit', value: 'limit' },
      { name: 'page', value: 'page' },
    ],
    fields: '{...ListUnitReservationRefundsResponseFields}',
    fragments: [Fragments.listUnitReservationRefundsResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};

export const GET_UNIT_RESERVATION_REFUND_BY_OPPORTUNITY = (props = {}) => {
  const defaultProps = {
    type: 'query',
    name: 'getUnitReservationRefundByOpportunity',
    args: [
      { name: 'opportunity_id', type: 'String', required: true },
    ],
    argsMap: [
      { name: 'opportunity_id', value: 'opportunity_id' },
    ],
    fields: '{...UnitReservationRefundFields}',
    fragments: [Fragments.unitReservationRefundResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};

export const GET_UNIT_RESERVATION_REFUND = (props = {}) => {
  const defaultProps = {
    type: 'query',
    name: 'getUnitReservationRefund',
    args: [
      { name: 'refund_id', type: 'String', required: true },
    ],
    argsMap: [
      { name: 'refund_id', value: 'refund_id' },
    ],
    fields: '{...UnitReservationRefundFields}',
    fragments: [Fragments.unitReservationRefundResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};
